<template>
  <div>
    <div v-if="oven">
      <v-card>
        <v-alert v-model="addUserAlert" dismissible type="warning">{{ addUserAlertMessage }}</v-alert>
        <v-card-title>
          <span class="headline">Ajout de utilisateur à : {{ oven.name }} {{ oven.macAddress }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                Adresse EMAIL
                <v-text-field
                  v-model="email"
                  v-on:keyup.enter="addUser()"
                  autofocus
                  :rules="emailRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" flat large @click="$emit('close'); reset()">Annuler</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat large @click="addUser()">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["oven"],
  data: () => ({
    currentValue: null,
    email: null,
    addUserAlert: false,
    addUserAlertMessage: null,
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  methods: {
    // ajoute un four
    addUser() {
      this.api
        .post("admin/ovens/" + this.oven.id + "/users", { email: this.email })
        .then(res => {
          this.$emit("close");
          this.$emit("reload");
          this.reset();
        })
        .catch(err => {
          this.addUserAlertMessage = err.message;
          this.addUserAlert = true;
          console.error(err.message);
        });
    },
    // reset tout
    reset() {
      this.email = null;
      this.addUserAlert = false;
      this.addUserAlertMessage = null;
    }
  }
};
</script>
